module.exports = __webpack_public_path__ + "static/textmaster-apikey-f7c687712817de0b226794259514accb.jpg";